<template>
  <div name="reports">

    <header class="w-95p mx-auto my-6">
                              <ul class="actions right" >
   
    <li v-if="selectedPupil != undefined">
                             <button
                                  type="button"
                                   class="bg-red-400 text-white hover:bg-red-500 font-bold py-2 px-4 mr-2 rounded  icon fa-trash-alt"
                                   title="Clear Selected Pupil"
                                   @click="selectedPupil = null"
                                  >
                                  Clear Selected Pupil
                                </button>
                      </li>

                    
                               <li>
                             <button
                                  type="button"
                                   class="bg-blue-400 text-white hover:bg-blue-500 font-bold py-2 px-4 mr-2 rounded  icon fa-chart-bar"
                                   title="Measurements"
                                   @click="showMeasures()"
                                  >
                                  Measurements
                                </button>
                      </li>

               
                    </ul>


            <h2 class="text-2xl font-semibold">Health Measures {{title}}</h2>            
          </header>

   <section v-if="!currentAccess.physicalAccess">
     <p class="font-bold mb-2 text-red-400">You do not have access to this feature</p>
     <p>
      If you wish to discuss / upgrade your current access to include custom features please contact us.</p>
   </section>  

   <div>


 <section v-if="errored" class="card">
    <p>We are not able to retrieve this information at the moment, please try back later</p>
  </section>

      <div v-else >
        <measuresChart v-if="selectedPupil != undefined"  :measures="measures" class="w-95p mx-auto block bg-white"></measuresChart>

       <pupilselect v-else :pupilsSelected="[]"  @pupil-selected="selectPupil" class="bg-list-grey py-6 rounded mb-6"></pupilselect>

      
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { HealthService } from "@/services/health.service";

const noaccess = () => import("@/components/NoAccess.vue");
const measuresChart = () => import("@/components/charts/TheMeasuresChart.vue");
const pupilselect = () => import('@/components/helpers/PupilSelect.vue')

export default {
  name: "reports",
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess"
    }),
    componentLoaded() {
      return this.assessments.length > 0;
    },
    title() {
      return this.selectedPupil == undefined ? 'By Pupil' : "- " + this.selectedPupil.name
    }
  },
  data() {
    return {
      loading: true,
      errored: false,
      measures: [],
      selectedPupil: null
    };
  },
  created() {
  },
  mounted() {

  },
  methods: {
    fetchMeasurements() {
      SchoolService.getAll("health-measurements/pupils/" + this.selectedPupil.identifier)
        .then(response => this.buildMeasurementList(response.data))
        .catch(err => {
          console.log("measures " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));

    },
    buildMeasurementList(data) {
      this.measures = data;
    },
    printReport() {
      window.print();
    },
    showMeasures() {
        this.$router.push({ name: 'HealthMeasures'})
    },
    selectPupil(pupil) {
      this.selectedPupil = pupil
      this.fetchMeasurements()
    }

  },
  components: {
    measuresChart,
    pupilselect,
    noaccess
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
